export const TEXT = {
  DISPLAY_1: {
    fontFamily: 'Manrope',
    fontSize: '4.5rem', // 72/16
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: -2.88,
  },
  DISPLAY_2: {
    fontFamily: 'Manrope',
    fontSize: '3.75rem', // 60/16
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: -2.4,
  },
  DISPLAY_3: {
    fontFamily: 'Manrope',
    fontSize: '3rem', // 48/16
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: -1.92,
  },
  DISPLAY_4: {
    fontFamily: 'Manrope',
    fontSize: '2.5rem', // 40/16
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: -1.6,
  },
  DISPLAY_5: {
    fontFamily: 'Manrope',
    fontSize: '2.25rem', // 36/16
    fontWeight: 600,
    lineHeight: 1.22,
    letterSpacing: -0.72,
  },
  H1: {
    fontFamily: 'Manrope',
    fontSize: '1.875rem', // 30/16
    fontWeight: 600,
    lineHeight: 1.27,
    letterSpacing: -0.6,
  },
  H2: {
    fontFamily: 'Manrope',
    fontSize: '1.5rem', // 24/16
    fontWeight: 600,
    lineHeight: 1.33,
    letterSpacing: -0.48,
  },
  H3: {
    fontFamily: 'Manrope',
    fontSize: '1.25rem', // 20/16
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: -0.4,
  },
  H4: {
    fontFamily: 'Manrope',
    fontSize: '1.125rem', // 18/16
    fontWeight: 600,
    lineHeight: 1.56,
    letterSpacing: 0,
  },
  H5: {
    fontFamily: 'Manrope',
    fontSize: '1rem', // 16/16
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: 0,
  },
  H6: {
    fontFamily: 'Manrope',
    fontSize: '0.875rem', // 14/16
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: 0,
  },
  BUTTON: {
    fontFamily: 'Mulish',
    fontSize: '0.875rem', // 14/16
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  SUBTITLE1: {
    fontFamily: 'Mulish',
    fontSize: '1rem', // 16/16
    fontWeight: 400,
    lineHeight: 1.47,
    letterSpacing: -0.16,
  },
  BODY1: {
    fontFamily: 'Mulish',
    fontSize: '0.925rem', // 14.8/16
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: -0.15,
  },
  BODY2: {
    fontFamily: 'Mulish',
    fontSize: '0.875rem', // 14/16
    fontWeight: 400,
    lineHeight: 1.43,
    letterSpacing: -0.14,
  },
  CAPTION: {
    fontFamily: 'Mulish',
    fontSize: '0.8rem', // 12.8/16
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: -0.13,
  },
  CAPTION2: {
    fontFamily: 'Mulish',
    fontSize: '0.75rem', // 12/16
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
}
